<template>
  <div class="cancellation-container">
    <div class="cancellation-card">
      <h2 class="title">Que tal mais 3 meses por nossa conta?</h2>

      <p class="message">
        Sabemos que mudar a forma de cuidar do dinheiro leva um tempo e é por isso que queremos te oferecer mais 3 meses
        de acesso gratuito. <br>
      </p>
      <p class="message">
        Assim, você continua usando todos os recursos do app, sem nenhuma cobrança, e decide com calma se faz sentido seguir com a gente.
      </p>
      <p class="message">
        É só clicar pra ativar os 3 meses grátis:
      </p>
      <div class="action-buttons">
        <button class="btn btn-primary" @click="$emit('activate-free-months')">
          Ativar 3 meses grátis
        </button>
      </div>

      <p class="secondary-message">
        Se depois desse período você ainda quiser sair, tudo certo. Mas a gente acredita que, com mais tempo, o app pode
        te mostrar mais resultados.
      </p>

      <div class="secondary-action">
        <button class="btn-text" @click="$emit('continue-cancellation')">
          Quero cancelar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CancellationIncentive'
}
</script>

<style scoped>
.cancellation-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.cancellation-card {
  border-radius: 10px;
  padding: 30px;
  max-width: 600px;
  width: 100%;
}

.title {
  color: #fff;
  font-size: 28px;
  margin-bottom: 20px;
  text-align: center;
}

.message {
  color: #e4e4e4;
  font-size: 16px;
  margin-bottom: 15px;
  line-height: 1.5;
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.btn {
  padding: 12px 24px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-primary {
  background-color: #cb5540;
  color: white;
  border: none;
}

.btn-primary:hover {
  background-color: #a8473a;
}

.secondary-message {
  color: #e4e4e4;
  font-size: 16px;
  margin: 25px 0 15px;
  text-align: center;
}

.secondary-action {
  display: flex;
  justify-content: center;
}

.btn-text {
  background: none;
  border: none;
  color: #cb5540;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
}

.btn-text:hover {
  color: #a8473a;
}
</style>
